var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cls } from "@iscr/views/NUI/utils";
import React, { useRef } from "react";
const DEBUG = true;
const UploadButton = ({ className, onFile, icon = "file", label = "Upload File", accept = null, multiple = false, color, basic = false, size, }) => {
    const fileRef = useRef(null);
    const variant = basic ? cls("basic", color) : (color !== null && color !== void 0 ? color : "green");
    return (_jsxs("label", { className: cls("label-no-margin ui", size, variant, "button", className), style: {
            whiteSpace: "nowrap",
            display: "flex",
            justifyContent: "center",
        }, children: [_jsx("input", { ref: fileRef, type: "file", accept: accept !== null && accept !== void 0 ? accept : undefined, multiple: multiple, onChange: (_) => __awaiter(void 0, void 0, void 0, function* () {
                    try {
                        if (onFile && fileRef.current && fileRef.current.files) {
                            onFile(Array.from(fileRef.current.files));
                        }
                        setTimeout(() => {
                            if (fileRef.current)
                                fileRef.current.value = "";
                        }, 500);
                    }
                    catch (err) {
                        if (DEBUG)
                            console.log("error", err);
                    }
                }), style: {
                    width: "0.1px",
                    height: "0.1px",
                    opacity: 0,
                    overflow: "hidden",
                    position: "absolute",
                    zIndex: -1,
                } }), icon && _jsx("i", { className: `ui ${icon} icon` }), label] }));
};
export default UploadButton;
